import React from 'react';

import { WrappedFieldProps } from 'redux-form/lib/Field';
import { ValidationError } from 'exception/Exception.types';
import { Box } from '@mui/material';

import { ErrorWrapper } from './Dropzone.s';

type DropzoneErrorProps = {
  meta: WrappedFieldProps['meta'];
};

export const PathError: React.FC<{ message: string; path: string }> = ({ message, path }) => (
  <Box sx={{ padding: '20px 0' }}>
    <p>{message}</p>
    <ul>
      {path?.split(',').map((cell: string, index: number) => (
        <li key={index}>{cell}</li>
      ))}
    </ul>
  </Box>
);

export const DropzoneError: React.FC<DropzoneErrorProps> = ({ meta }: DropzoneErrorProps) => {
  const { error } = meta;

  if (!error) {
    return null;
  }

  if (typeof error === 'string') {
    return <ErrorWrapper>{error}</ErrorWrapper>;
  }

  if (error.error) {
    return (
      <>
        {(error.error as ValidationError[]).map(({ message, path }) => (
          <PathError key={path} message={message} path={path} />
        ))}
      </>
    );
  }

  const { message, path } = error;
  return <PathError message={message} path={path} />;
};
